import React, { ReactNode } from 'react';
import { Pressable, View } from 'react-native';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import Label from '../Label';

export interface MissionPromotionBannerProps {
  title: string;
  subtitle: string;
  icon: ReactNode;
  backgroundColor: string;
  titleColor: string;
  subtitleColor: string;
  chevronColor: string;
  onPress(): void;
}

const MissionPromotionBanner = (props: MissionPromotionBannerProps) => {
  return (
    <View style={{ marginHorizontal: 12, marginBottom: 8 }}>
      <Pressable
        onPress={props.onPress}
        style={{
          borderRadius: 8,
          backgroundColor: props.backgroundColor,
          minHeight: 58,
          paddingHorizontal: 10,
          paddingVertical: 8,
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <View style={{ flexDirection: 'row', alignItems: 'center', flex: 1 }}>
          <View style={{ width: 36, height: 32, marginRight: 10, alignItems: 'center', justifyContent: 'center' }}>{props.icon}</View>
          <View style={{ flex: 1, minWidth: 0, paddingRight: 8 }}>
            <Label numberOfLines={0} style={{ color: props.titleColor, fontWeight: '700', fontSize: 19, lineHeight: 21 }}>{props.title}</Label>
            <Label numberOfLines={0} style={{ color: props.subtitleColor, fontWeight: '700', fontSize: 14, marginTop: 2, lineHeight: 16 }}>{props.subtitle}</Label>
          </View>
          <FontAwesomeIcon icon={faChevronRight} size={16} color={props.chevronColor} />
        </View>
      </Pressable>
    </View>
  );
};

export default MissionPromotionBanner;
